/* eslint-disable quotes */
export default {
  init() {
    if ($(".gallery_layout").length > 0) {
      $(".gallery_layout").lightGallery({
        thumbnail: true,
        selector: ".gallery_item",
        exThumbImage: "data-exthumbimage",
        // autoplay: true,
        //                enableThumbSwipe: false
        fullScreen: false,
        download: false,
      });
    }
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateGallery.js